import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import AssetModalContentWrap from "../modal/orgSearchResultsAssetModalContentWrap";
import { PlainCard as Card } from "../../show_page/sections/asset/card";

class AssetCard extends React.Component {
  state = {
    attachments: [],
    showModal: false
  };

  handleSelectionClick = (e) => {
    const { asset, position, shiftSelect, toggleSelected } = this.props;
    e.stopPropagation();
    e.persist();
    if (e.shiftKey) {
      shiftSelect(asset.id, position);
    } else {
      toggleSelected(asset.id);
    }
  };

  showModal = () => {
    const { asset } = this.props;
    if (BFG.embedView && asset.type === "texts") {
      this.postEmbedMessageText();
    } else {
      $.ajax({
        context: this,
        type: "GET",
        url: `/api/v4/assets/${
          asset.id
        }/attachments?fields=best_metadata,other_metadata,download_url,thumbnail_url,view_thumbnail_retina,extension,thumbnailed,position`,
        beforeSend: (xhr) => {
          xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
        },
        success: (response) => {
          const sortedAttachments = response.data.sort((a, b) => (
            a.attributes.position > b.attributes.position ? 1 : -1
          ));
          this.setState({ attachments: sortedAttachments, showModal: true });
        }
      });
    }
  }

  postEmbedMessageText() {
    const { asset } = this.props;
    // printuiFrameId defined in Rails controller/view
    const attachmentEmbedInfo = {
      key: asset.id,
      name: asset.attributes.name,
      type: "embed",
      url: asset.attributes.thumbnail_url,
      displayUrl: asset.attributes.thumbnail_url,
      description: asset.attributes.description,
      text: true,
      printuiFrameId: window.printuiFrameId,
    };

    window.parent.postMessage(attachmentEmbedInfo, '*');
  }

  tagNames() {
    return this.props.tags.map((tag) => tag.attributes.name);
  }

  render() {
    const { asset, brandfolder, libraryName, selected, tags } = this.props;

    return (
      <React.Fragment>
        <Modal
          bsSize="large"
          show={this.state.showModal}
          className="modal-dialog modal-lg modal-asset"
          onHide={() => this.setState({ showModal: false })}
        >
          <button
            className="close close-modal"
            data-dismiss="modal"
            type="button"
            onClick={() => this.setState({ showModal: false })}
          >
            <span className="bff-close" aria-label="close" />
          </button>
          <AssetModalContentWrap
            brandfolder={brandfolder}
            asset={asset}
            tags={tags}
            attachments={this.state.attachments}
            libraryName={libraryName}
          />
        </Modal>
        <div id={asset.id}>
          <Card
            list={false}
            oldTypes
            editable={false}
            asset={asset}
            selected={selected}
            handleSelectionClick={this.handleSelectionClick}
            onVisitAsset={this.showModal}
            alwaysOpenInModal
          />
        </div>
      </React.Fragment>
    );
  }
}

AssetCard.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  brandfolder: PropTypes.shape({}).isRequired,
  libraryName: PropTypes.string.isRequired,
  position: PropTypes.number,
  selected: PropTypes.bool,
  shiftSelect: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  toggleSelected: PropTypes.func,
};

export default AssetCard;
